module.exports = __webpack_public_path__ + "img/analytics-hero-banner.4077615f.png";